import axios from 'axios';
import { getRequestAuthHeader } from 'utils/apiError';
import { redirectToLoginAfterSessionExpired } from 'utils/sessionExpiredRedirect';

// const baseURL = 'https://landlordportal-dev.leapeasyapi.com/api';
// const baseURL = 'https://landlordportal.leapeasyapi.com/api';
const baseURL = process.env.REACT_APP_API;
export const api = axios.create({
  baseURL,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status !== 401 || typeof window === 'undefined') {
      return Promise.reject(error);
    }
    // Wrong password on sign-in, etc. — no session header was sent
    if (!getRequestAuthHeader(error.config)) {
      return Promise.reject(error);
    }
    redirectToLoginAfterSessionExpired();
    return Promise.reject(error);
  },
);

export const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `${token}`,
    },
  };
};

export const getDocAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    responseType: 'blob',
    headers: {
      Authorization: `${token}`,
      // 'Content-Type': 'application/json',
      // Accept: 'application/pdf'
    },
  };
};
